var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDraftFlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48ZM30.9817 10.735C31.3067 10.41 31.7017 10.1614 32.1441 10.0033C32.5865 9.84515 33.0676 9.78067 33.56 9.81351C34.0525 9.84634 34.5465 9.97584 35.014 10.1946C35.4815 10.4134 35.9133 10.7172 36.2848 11.0886C36.6562 11.46 36.9599 11.8918 37.1787 12.3593C37.3975 12.8268 37.527 13.3209 37.5598 13.8133C37.5927 14.3058 37.5282 14.7869 37.3701 15.2293C37.212 15.6717 36.9633 16.0666 36.6383 16.3916L34.2521 18.7779C33.8615 19.1684 33.2284 19.1684 32.8378 18.7779L28.5955 14.5355C28.2049 14.145 28.2049 13.5118 28.5955 13.1213L30.9817 10.735ZM18.4993 34.5293C18.3619 34.6666 18.1876 34.761 17.9976 34.8009L12.6284 35.9277C11.922 36.0759 11.296 35.4499 11.4443 34.7436L12.5711 29.3744C12.611 29.1843 12.7054 29.01 12.8427 28.8727L25.536 16.1793C25.9266 15.7888 26.5597 15.7888 26.9502 16.1793L31.1926 20.4217C31.5832 20.8122 31.5832 21.4454 31.1926 21.8359L18.4993 34.5293Z",
    fill: "#C9CCD3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraftFlow);
export default __webpack_public_path__ + "static/media/draftFlow.62fbd720c4dd0f1f1f72e57c6d52d257.svg";
export { ForwardRef as ReactComponent };